import React, { Component } from "react";

import now_song_chat from "../../../img/ppe/now_song_chat.png";

// Load images for part 2 subject
import ascencia_website_home from "../../../img/pp/ascencia/ascencia_website_home.png";
import ascencia_website_no_login from "../../../img/pp/ascencia/ascencia_website_no_login.png";
import ascencia_website_shards from "../../../img/pp/ascencia/ascencia_website_shards.png";
import ascencia_website_discord_server_list from "../../../img/pp/ascencia/ascencia_website_discord_server_list.png";
import ascencia_website_discord_server_module from "../../../img/pp/ascencia/ascencia_website_discord_server_module.png";
import ascencia_website_profile_user from "../../../img/pp/ascencia/ascencia_website_profile_user.png";
import ascencia_website_help from "../../../img/pp/ascencia/ascencia_website_help.png";
import ascencia_website_help_found from "../../../img/pp/ascencia/ascencia_website_help_found.png";

import ascencia_music_play_command from "../../../img/pp/ascencia/ascencia_music_play_command.png";
import ascencia_website_players from "../../../img/pp/ascencia/ascencia_website_players.png";
import ascencia_website_player_in_progress from "../../../img/pp/ascencia/ascencia_website_player_in_progress.png";
import ascencia_music_nowplaying_card from "../../../img/pp/ascencia/ascencia_music_nowplaying_card.png";

import ascencia_embed_help from "../../../img/pp/ascencia/ascencia_embed_help.png";
import ascencia_ping from "../../../img/pp/ascencia/ascencia_command_ping.png";

let imagesAsMusic = [
	ascencia_music_play_command,
	ascencia_website_players,
	ascencia_website_player_in_progress,
	ascencia_music_nowplaying_card
];

let imagesAsInteraction = [
	ascencia_embed_help,
	ascencia_ping
];

let imagesAsWebsite = [
	ascencia_website_home,
	ascencia_website_no_login,
	ascencia_website_shards,
	ascencia_website_discord_server_list,
	ascencia_website_discord_server_module,
	ascencia_website_profile_user,
	ascencia_website_help,
	ascencia_website_help_found
];

export default class Ascencia extends Component {
	render() {
		return (
			<>
				<div className="container">
					<div className="row mt-5">
						<div className="col-lg-12">
							<div className="section-title">
								<h2>Information</h2>
								<p>
									<b>❯ Project(s) : </b> Projet Ascencia<br/>
									<b>❯ Langage de Programation : </b> JavaScript, SCSS<br/>
									<b>❯ Technologie(s) : </b> NodeJS, Lavalink, SocketIO<br/>
									<b>❯ Base de données : </b> MongoDB<br/>
									<b>❯ Date : </b> 2018 - en cours<br/>
									<b>❯ Lien Site Web : </b> <a href="https://ascencia.re/" target="_blank" rel="noreferrer noopener">Ascencia</a><br/>
									<b>❯ Lien Github : </b> <a href="https://github.com/pedrokarim/Ascencia" target="_blank" rel="noreferrer noopener">Source Code</a> (pour l'instant en privé)<br/>
								</p>
							</div>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">Robot Discord</h3>

							<h4 className="mb-20">Introduction</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={ascencia_website_home} className="img-gal">
										<img src={ascencia_website_home} alt="" className="img-fluid" />
									</a>
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<p>
										Le projet Ascencia est un petit projet qui vise à créer un robot discord avec une librairie javascript
										permettant d'écrire, interagir et faciliter la conception de robots Discord. Au tout début de la création de ce projet, j'avais pour objectif
										d'apprendre à utiliser le langage javascript côté back-end donc NodeJS et pour l'instant ce fut un franc succès.
										<br/>
										<br/>
										Se robot que j'ai créé peut être désigné comme les temps multifonctionnels puisqu'il possède diverses
										fonctionnalités que j'ai développées petit à petit avec le temps, je vais vous en présenter quelques-uns ci-dessous.

										<em>
											Remarque : les screenshots que vous allez voir ci-dessous, les descriptions du robot sont écrites en anglais,
											c'est parce que le robot est multi langage et que pendant la prise des screenshots, il est configuré en anglais mais il peut aussi être figurer en français.
										</em>
									</p>
								</div>
							</div>

							<h4 className="mb-20">Interagir avec le robot Ascencia</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={ascencia_embed_help} className="img-gal">
										<img src={ascencia_embed_help} alt="" className="img-fluid" />
									</a>
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<p>
										Interagir avec le robot Ascencia et techniquement pas très compliquées, il suffit juste d'être présent
										sur un serveur où le bot Ascencia est présent aussi et on peut lui faire exécuter divers commandes spécifiques.
										Pour avoir une liste de tout les commandes disponible sur le robot ascencia il suffit d'ecrire dans le chat <code>@ascencia help</code>.
									</p>
								</div>
							</div>

							<h4 className="mb-20">Lecture de musique dans les canaux vocaux</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={ascencia_music_play_command} className="img-gal">
										<img src={ascencia_music_play_command} alt="" className="img-fluid" />
									</a>
									{imagesAsMusic.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<p>
										Au tout début quand j'ai commencé à développer ce robot discord la tradition tacite était de créer
										un robot capable de lire des musiques dans les canaux vocaux des serveurs Discord,
										Donc j'ai développer cette fonctionnalité mais j'ai voulu la pousser un peu plus loin. J'ai mis en place un
										serveur de musique, un serveur dénommé <a href="https://github.com/freyacodes/Lavalink">Lavalink</a>
										tout utilisant la librairie <a href="https://github.com/Deivu/Shoukaku">Shoukaku</a> permettant donc de communiquer avec ce serveur
										de musique et ensuite j'ai fait en sorte que l'on puisse voir le statut des musiques qui sont actuellement lecture sur les serveurs directement sur
										le site web avec une libraire facilitant les interactions <a href="https://fr.wikipedia.org/wiki/Socket">Socket</a> (Client/Serveur).
									</p>
									<p>
										Ce projet m'a permis de d'apprendre à générer des images avec <a href="https://developer.mozilla.org/fr/docs/Web/API/Canvas_API">l'API Canvas JS</a> pour générer les cartes de lecture en cours pour la musique,
										j'ai utilisé la librairie appeler <a href="https://github.com/Automattic/node-canvas">node-canvas</a> qui permet de générer des images avec
										la même syntaxe que Canvas de JavaScript.
									</p>
								</div>
							</div>

						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">Site Web</h3>

							<h4 className="mb-20">Introduction</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={ascencia_website_discord_server_list} className="img-gal">
										<img src={ascencia_website_discord_server_list} alt="" className="img-fluid" />
									</a>
									{imagesAsWebsite.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<p>
										Pour ce projet, un site web est devenu rapidement nécessaire puisque par exemple pour la configuration des différents dans
										le robot la configuration par les commandes devient un petit peu pour les utilisateurs donc, une interface web est recommandée
										pour pouvoir faire des configurations complexes.
										<br/>
										J'ai dû chercher une technologie viable qui m'intéresserait à apprendre, du coup, je me suis tourné vers ReactJS, Redux pour le
										front-end et ExpressJS pour le côté back-end et API.
									</p>

									<p>
										Donc typiquement il fallait développer un système de connexion des utilisateurs sur le site web, faire la gestion
										des serveurs discord en fonction de l'utilisateur qui se connecte, gérer les permissions de ces utilisateurs pour
										qu'ils ne puissent pas modifier une donnée dont ils n'ont techniquement pas accès, donc il fallait aussi gérer ses
										permissions par rapport à ceux de Discord donc toute une mise en place complexe de gestion des permissions et de gestion d'accès aux ressources.
										<br/>
										Et bien sûr le serveur socket avec <a href="https://socket.io/fr/">SocketIO</a> qui permet les interactions silencieuse avec le serveur pour la mise à jour
										automatique des status musiques et status des différentes <a href="https://discord.com/developers/docs/topics/gateway#sharding"></a> Shards du processus du robot.
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>
			</>
		);
	}
}